import { gql } from "@apollo/client";

export const GENERATE_PRE_SIGNED_URL_MUTATION = gql`
  mutation generate3dPreSignedURL($input: S3PresignedURLInput!) {
    generate3dPreSignedURL(input: $input) {
      type
      url
      fileId
    }
  }
`;

export const GENERATE_3DPREVIEW_PRE_SIGNED_URL_MUTATION = gql`
  mutation generate3dPreviewPreSignedURL($input: S3PresignedURLInput!) {
    generate3dPreviewPreSignedURL(input: $input) {
      type
      url
      fileId
    }
  }
`;
